<template>
  <div :class="_css">
    <span
      v-if="item.changeType && !suppressBadges"
      :class="'changeBadge-' + item.changeType"
      >{{ changeBadgeEval(item.changeType) }}</span
    >

    <cat-attribute-readonly
      :label="item.texts && item.texts.label"
      :value="
        item.value && typeof item.value == 'object' ? undefined : item.value
      "
      :raw="!item.texts"
      :class="(item.styles || []).concat(['collapsible-body'])"
    >
      <a
        v-if="item.value && typeof item.value == 'object' && item.value.link"
        :href="item.value.link"
        class="link"
        target="_blank"
        download
        >{{ item.value.text }}</a
      >
      <span v-else-if="item.value && typeof item.value == 'object'">{{
        item.value.text
      }}</span>
    </cat-attribute-readonly>
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatAttributeReadonly from "@/components/catAttributeText/catAttributeReadonly.vue";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatDiffAttributeSingle",
  components: { CatAttributeReadonly },
  props: {
    item: [Object],
    suppressBadges: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeBadgeEval: function (type) {
      if (!type || "none" === type) {
        return null;
      }
      return this.resolveTxt("diff.badge." + type, type);
    }
  },
  computed: {
    _css: function () {
      const classes = {
        suppressBadges: this.suppressBadges
      };
      if (this.item.changeType) {
        classes.attributeChange = true;
        classes["changeType-" + this.item.changeType] = true;
      }
      return classes;
    }
  }
});
</script>
